import React, { useEffect, useState } from 'react';
import { useIdleTimer } from 'react-idle-timer';
import { Routes, Route, Link as RouterLink, Navigate, useNavigate } from 'react-router-dom';
import { AuthenticatedTemplate, UnauthenticatedTemplate } from "@azure/msal-react";
import { MsalProvider, useIsAuthenticated } from "@azure/msal-react";
import { Button, ButtonGroup, Typography, AppBar, Box, Toolbar } from "@mui/material";
import { HashRouter as HashRouter, BrowserRouter as Router } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css'; // Import Bootstrap CSS
import {listJobs} from '../api/api'; // Adjust the path as necessary
import ListJobs from './ListJobs';
import CreateJob from './CreateJob';
import GuidelineCalculator from './guideline_calculator';
import GloriaMrio from './GloriaMrio';
import Metadata from './Metadata';
import Guidelines from './Guidelines';
import ContactUs from './ContactUs';
import Footprint from './footprint';
import CreateJobHandler from './CreateJob';

const FootprintCalculator = () => {
  const [activeTab, setActiveTab] = useState('tab1');
  const [jobs, setJobs] = useState([]);
  const [jobId, setJobId] = useState(null); // Keep only one declaration of jobId
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const handleUpload = () => {
    setActiveTab("tab1"); // Set tab1 when the button is clicked
  };
  const resources = [
    { href: "https://wedocs.unep.org/handle/20.500.11822/44825", src: "/carbon2.png", alt: "Carbon Icon" },
    { href: "https://wedocs.unep.org/20.500.11822/46449", src: "/energy2.png", alt: "Energy Icon" },
    { href: "https://wedocs.unep.org/20.500.11822/46450", src: "/land2.png", alt: "Land Icon" },
    { href: "https://wedocs.unep.org/handle/20.500.11822/44824", src: "/material2.png", alt: "Material Icon" },
    { href: "https://wedocs.unep.org/20.500.11822/46451", src: "/water2.png", alt: "Water Icon" },
  ];

  const renderContent = () => {
    switch (activeTab) {
      case 'tab4':
        return (
          <div className="container-fluid">
            <style>
                {`
                @import url('https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700&display=swap');
                  .container-fluid {
                    padding-right: 0 !important;
                    padding-left: 0 !important;
                  }
                  .home-banner img {
                    display: block;
                    margin: 0 auto;
                  }
                  body {
                    font-family: 'Roboto', sans-serif;
                  }
                `}
            </style>           
          <div className="col-12">
            <Typography variant="h5" paragraph sx={{ color: '#009EDB', paddingTop: '1em', paddingBottom: '10px', textAlign: 'justify' }}>
              Monitor the status and manage your footprint calculation jobs: (View Jobs)
            </Typography>

            <ul>
              <li><strong>Job ID:</strong> A unique identifier.</li>
              <li>
                <strong>State:</strong>
                <ul>
                  <li><strong>Unknown:</strong> The job state is unknown.</li>
                  <li><strong>Progressing:</strong> The job is currently in process.</li>
                  <li><strong>Terminated:</strong> The job has been completed.</li>
                </ul>
              </li>
              <li><strong>Status:</strong> Shows the current processing phase.</li>
              <li>
                <strong>Actions:</strong>
                <ul>
                  <li><strong>Delete:</strong> Remove the job from the list.</li>
                  <li><strong>Download:</strong> Download the calculated footprints in a ZIP file.</li>
                </ul>
                Open the ZIP file and extract the calculated footprints. The ZIP file includes the filled <strong>input_template</strong> with your national data. Each footprint calculation (e.g., <strong>ISO_ENERGY_results</strong>) is saved in a separate Excel file.
              </li>   
            </ul>
            <Typography variant="body2" sx={{ fontStyle: 'italic', mt: 2 }}>
              Note: The footprint tool will autofill the remaining output files, including RME Exports and RME Imports sheets.
            </Typography>
          </div>
          </div>
        );
      case 'tab3':
        return (
          <div className="container-fluid">
            <style>
                {`
                @import url('https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700&display=swap');
                body {
                  font-family: 'Roboto';
                }
                  .container-fluid {
                    padding-right: 0 !important;
                    padding-left: 0 !important;
                  }
                  .home-banner img {
                    display: block;
                    margin: 0 auto;
                  }
                `}
            </style>
            <div className="container" style={{ textAlign: 'left', position: 'center' }}>
            <Typography variant="h5" paragraph sx={{ color: '#009EDB', paddingTop: '1em', paddingBottom: '1px', textAlign: 'left' }}>
            Metadata
            </Typography> 
            <Typography variant="body1" paragraph sx={{ textAlign: 'left' }}>
            The Metadata section provides detailed information on the various footprints calculation. This can help you understand the metrics and methods behind your footprint calculations.
        </Typography>        
              <div className="row gx-4 justify-content-md-center">
                {resources.map(({ href, src, alt }, index) => (
                  <div key={index} className="col justify-content-md-center" style={{ padding: '10px' }}>
                    <div className="card" style={{ width: '50%', height: 'auto' }}>
                      <a href={href} target="_blank" rel="noopener noreferrer">
                        <img 
                          className="card-img-top" 
                          src={src} 
                          alt={alt} 
                          style={{ width: '100%', height: 'auto' }} 
                          onError={(e) => { 
                            e.target.src = 'fallback-image.png'; 
                            console.error('Image not found:', e.target.src); 
                          }}
                        />
                      </a>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        );
        case 'tab1':
          return (
            <div className="container-fluid">
              <style>
                  {`
                  @import url('https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700&display=swap');
                  body {
                    font-family: 'Roboto';
                  }
                    .container-fluid {
                      padding-right: 0 !important;
                      padding-left: 0 !important;
                    }
                    .home-banner img {
                      display: block;
                      margin: 0 auto;
                    }
                  `}
              </style>
              <div className="container job-list">
              <ListJobs />
              </div>
            </div>
          );        
        case 'tab2':
        return (
          <div className="container-fluid">
            <style>
                {`
                @import url('https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700&display=swap');
                body {
                  font-family: 'Roboto';
                }
                  .container-fluid {
                    padding-right: 0 !important;
                    padding-left: 0 !important;
                  }
                  .home-banner img {
                    display: block;
                    margin: 0 auto;
                  }
                `}
            </style>
            <div className="container">
            <CreateJob setActiveTab={setActiveTab} />              
            </div>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div className="container-fluid">
        <style>
            {`
            @import url('https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700&display=swap');
            body {
              font-family: 'Roboto';
            }
              .container-fluid {
                padding-right: 0 !important;
                padding-left: 0 !important;
              }
              .home-banner img {
                display: block;
                margin: 0 auto;
              }
            `}
        </style>
           {/* Banner Image: Only visible when Home link is active */}
           <div className="home-banner">
          <img src="/Banner 1.png" alt="Footprint Banner" style={{ width: '100%', height: '350px', objectFit: 'cover' }}/>
        </div>
        <section id="calculator" className="my-5 container">
          <div className="card-body d-flex flex-column align-items-center">
            {/* Navigation Tabs */}
            <div className="w-100">
              <ul className="nav nav-tabs justify-content-center flex-wrap mt-3">
                {['tab1', 'tab2', 'tab3', 'tab4'].map((tab, index) => (
                  <li className="nav-item" key={index}>
                    <button
                      className={`nav-link ${activeTab === tab ? 'active' : ''}`}
                      onClick={() => setActiveTab(tab)}
                    >
                      {tab === 'tab2' ? 'Create Job' : tab === 'tab1' ? 'View Jobs' : tab === 'tab3' ? 'Metadata' : 'Guidelines'}
                    </button>
                  </li>
                ))}
              </ul>
            </div>

            {/* Content Divs Below Tabs */}
            <div className="tab-content mt-3 w-100">
              {renderContent()}
            </div>
          </div>
        </section>
    </div>
  );
};

const HomePage = () => {
  const isAuthenticated = useIsAuthenticated();  // Access the authentication state

  return (
    <div className="container-fluid">
       {/*<AuthenticatedTemplate>
        <FootprintCalculator /> FootprintCalculator component included here *
  </AuthenticatedTemplate>*/}

    
        
        <div className="container-fluid">
        <style>
            {`
             @import url('https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700&display=swap');
              .container-fluid {
                padding-right: 0 !important;
                padding-left: 0 !important;
              }
              .home-banner img {
                display: block;
                margin: 0 auto;
              }
              body {
                font-family: 'Roboto';
              }
            `}
        </style>
          {/* Banner Image: Only visible when Home link is active */}
        <div className="home-banner">
          <img src="/Banner 1.png" alt="Footprint Banner" style={{ width: '100%', height: '350px', objectFit: 'cover' }}/>
        </div>
          <div className="container" sx={{overflow: 'visible', paddingTop:'10px'}}>
            <div className="col-12" style={{paddingBottom: '2em'}}>
                            {/* New Section Content */}
              <section id="home">
              <div class="row">
              <div style={{display: "flex", alignItems: "center", justifyContent: "space-between", gap: "30px", flexWrap: "wrap", }}>
              {/* TEXT */}
              <div style={{ flex: "1 1 500px" }}>
              <h3 style={{ marginBottom: "10px", color: "#009EDB",  paddingTop: '1em', paddingBottom: '5px'}}>
                    Global Footprint Tool
                  </h3>
                  <p style={{ textAlign: "left", lineHeight: "1.6" }}>
                  The Global Footprint Tool (GFT) enables statistical offices and other  entities to calculate their countries' environmental footprints across multiple dimensions, including carbon emissions, energy production, land use, material use, and water consumption, at a high quality, commensurate with the requirements of statistical reporting. The GFT also enables countries to report data on SDG Indicators 8.4.1/12.2.1 on Material Footprint.
                </p>
              </div>

              {/* IMAGE */}
              <div style={{ flex: "1 1 400px", textAlign: "center",  paddingTop: '1em', paddingBottom: '5px'}}>
                <img src="/Footprint graphic.png"  alt="Global Footprint Diagram" style={{width: "100%", maxWidth: "600px", height: "30vh",}}/>
              </div>
            </div>
              </div>
               
                
              <h3 style={{ marginBottom: "10px", color: "#009EDB",  paddingBottom: '5px'}}>
                Estimating Countries' Footprint
                </h3>
                <p variant="body1" paragraph sx={{textAlign: 'left'}}>
                Currently, the most used approach to estimate a country's footprint across many environmental and social domains uses Multi-Regional Input-Output (MRIO) analyses, which combine economic, social, and environmental statistics. Creating and updating MRIO tables requires high computing capacity from supercomputers that compile information from national statistics for many countries. Very few countries can carry out the footprint analysis on their own. The GFT provides this capability to countries by hosting and using the GLORIA MRIO database built by the University of Sydney using the IELab infrastructure for the UNEP International Resource Panel (UNEP IRP).
                </p>
                <p variant="body1" paragraph sx={{textAlign: 'left', paddingBottom: '2em'}}>
                Global footprint calculations strongly support actions against climate change, loss of nature, and pollution. Knowledge of the footprint data disaggregated by natural resource provides policymakers with critical information on how specific economic activity exerts pressure on the environment. This information also supports strategic decisions on actions at the national level to promote sustainable development.
                </p>
              </section>
            </div>
          </div>
         {/* Routes for Unauthenticated Users */}
         {!isAuthenticated && (
            <Routes>
              <Route path="/gloria-mrio" element={<GloriaMrio />} />
              <Route path="/metadata" element={<Metadata />} />
              <Route path="/Guidelines" element={<Guidelines />} />
              <Route path="/contact-us" element={<ContactUs />} />
              <Route path="/calculator" element={<Footprint />} />
              <Route path="/guideline_calculator" element={<guideline_calculator />} />
            </Routes>
          )}
        </div>
  
    </div>
  );
};

export default HomePage;
